<script lang="ts">
	import { createEventDispatcher, getContext, onMount } from 'svelte';
	import { getStepErrors, type StepUpdater, useStepFieldUpdater } from '../../Stepper/stepper';

	export let name: string;
	export let onUpdate: StepUpdater<string> | null = null;

	const hash = getContext<symbol>('stepHash');
	const { value, updateValue, markAsChanged, step } = useStepFieldUpdater<string>(hash, name);
	const errors = hash ? getStepErrors(hash) : null;

	const handleUpdate = (e: Event | string | number | boolean) => {
		const newVal = e instanceof Event ? (e.target as HTMLInputElement).value : e;

		updateValue((_, step) => (onUpdate && step ? onUpdate(newVal, step) : { [name]: newVal }));
	};

	const dispatch = createEventDispatcher();

	$: dispatch('value', $value);

	onMount(() => {
		dispatch('value', $value);
		addEventListener('change', (e: Event) => {
			markAsChanged();
			e.stopPropagation();
		});
		return () => removeEventListener('change', markAsChanged);
	});
</script>

<slot value={$value} error={$errors ? $errors[name] : null} {handleUpdate} />
